module.exports = __webpack_public_path__ + "img/logo-bei-white.d87e53d9.svg";